<template>
  <div>
    <h4 class="text-info">{{ order.client.phone }}</h4>
    <div>Проверка номера телефона: {{ order.client.phone }}</div>
    <div v-if="!webview">
      <button class="btn btn-info mw mt-3" @click="send">Продолжить</button>
    </div>
    <div v-else-if="message && webview">
      <h4 class="text-danger">{{ message }}</h4>
      <a class="btn mw mt-3" :href="`${webview}${additionalQuery}`"
        >Продолжить</a
      >
    </div>
  </div>
</template>
<script>
import { logger, errorNotify } from "../../../plugins/functions";

export default {
  computed: {
    additionalQuery() {
      try {
        return `&callback=${this.$store.state.host}/api/redirect/order/${this.order.id}/${this.partner.id}&companyId=${this.partner.api_public_key}`;
      } catch (error) {
        return "";
      }
    },
  },
  props: {
    order: {
      default: function () {
        return {};
      },
    },
    transaction: {
      default: function () {
        return null;
      },
    },
    partner: {
      default: function () {
        return {};
      },
    },
    updateOrder: {
      default: function () {},
    },
    value: {
      default: function () {},
    },
    createTransaction: {
      default: function () {},
    },
  },
  data() {
    return {
      loading: false,
      webview: null,
      message: "Требуется тратата",
    };
  },
  methods: {
    async send() {
      this.$loading(true);

      this.loading = true;

      const data = {
        phone: this.order.client.phone,
      };

      this.$http
        .post(
          `${this.partner["endpoint_url"]}v3/uzum/buyer/check-status?company_id=${this.partner.api_public_key}`,
          data,
          {
            headers: {
              Authorization: `Bearer ${this.partner["api_secret_key"]}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then(async (response) => {
          switch (response.data.data.status) {
            case 4:
              this.message = "Клиент верефицирован, можно продолжить скоринг";
              this.$emit("input", response.data.data);
              this.$emit("setStep", "order-add");
              // this.webview = response.data.data.webview;
              break;

            case 8:
              this.message = "Пользователь заблокирован";
              this.webview = response.data.data.webview;
              break;

            case 0:
              this.message = "Клиент не найден в системе PAYMART";
              this.webview = response.data.data.webview;
              break;

            case 1:
              this.message = "Необходимо добавить карту";
              this.webview = response.data.data.webview;
              break;

            case 5:
              this.message = "верификация в myid";
              this.webview = response.data.data.webview;
              break;

            case 12:
              this.message = "Необходимо добавить доверителя";
              this.webview = response.data.data.webview;
              break;

            case 2:
              this.message = "Ожидание модерации...";
              this.webview = response.data.data.webview;
              break;

            default:
              this.message = "Неизвестный статус от партнера";
              break;
          }

          this.$notify({
            title: "UZUM NASIYA (MKO)",
            message: this.message,
            icon: "ti-save",
            horizontalAlign: "right",
            verticalAlign: "top",
          });
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
        })
        .finally(() => {
          this.$loading(false);
          this.loading = false;
        });
    },
  },
};
</script>